function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIc1010ShoppingBagZh = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.315,
    height: 98,
    viewBox: "0 0 86.315 98",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "t3gi6up2ja"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 5713",
    style: {
      fill: "none"
    },
    d: "M0 0h86.315v98H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4203"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2587",
    style: {
      clipPath: "url(#t3gi6up2ja)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3927",
    d: "M64.838 24.322q.031-.624.032-1.257C64.87 10.325 55.194 0 43.258 0S21.646 10.325 21.646 23.066q0 .632.032 1.257H0l1.975 63.668a12.621 12.621 0 0 0 1.577 5.356 8.709 8.709 0 0 0 2.278 2.815 8.5 8.5 0 0 0 4.624 1.608c3.576.273 28.57.325 62.86.012a10.642 10.642 0 0 0 8.946-4.653 12.789 12.789 0 0 0 2.233-6.436l1.821-62.371zm-37.261.029v-.029C27.59 13.97 34.56 5.583 43.157 5.583s15.568 8.387 15.581 18.739v.029z",
    transform: "translate(0 .004)",
    style: {
      fill: "#fd0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4206"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3928",
    d: "M189.138 764.821c-.1.132-.205.279-.308.41a14.451 14.451 0 0 0 6.042 3.754 4.32 4.32 0 0 0-1.1 1.51 16.719 16.719 0 0 1-5.954-4.076 18.716 18.716 0 0 1-5.836 4.076 6.515 6.515 0 0 0-1.188-1.481 14.73 14.73 0 0 0 6.775-4.971zm-.308 11.086h5.25v1.569h-12.465v-1.569h1.585v-5.118h1.73v5.118h2.053v-7.523h1.848v3.021h3.915v1.569h-3.916z",
    transform: "translate(-167.794 -708.023)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3929",
    d: "M400.889 777.253a11.332 11.332 0 0 1-4.267 1.95 6.8 6.8 0 0 0-1.026-1.261 12.294 12.294 0 0 0 4.062-1.246zm7.772-2.478v1.437h-5.69v3.344h-1.73v-3.344h-5.587v-1.437h5.587v-.645h-4.223v-1.261h4.223v-.66h-4.957v-1.32h2.7a8.175 8.175 0 0 0-.543-1.07l.982-.22h-3.739v-1.364h1.994a13.392 13.392 0 0 0-.939-1.818l1.5-.5a9.537 9.537 0 0 1 1.115 2.053l-.7.264h1.349v-2.39h1.613v2.39h1.1v-2.39h1.642v2.39h1.305l-.528-.161a12.9 12.9 0 0 0 .938-2.111l1.833.425c-.411.674-.807 1.334-1.173 1.848h1.892v1.365h-3.871l1.378.352c-.323.352-.631.674-.895.939h2.83v1.32h-5.089v.66h4.4v1.261h-4.4v.645zM400.2 769.6a6.822 6.822 0 0 1 .587 1.1l-.792.191h4l-.528-.161c.235-.337.543-.777.748-1.129zm4.575 7.01c1.188.44 2.918 1.173 3.857 1.642l-1.232.953c-.851-.484-2.566-1.261-3.8-1.774z",
    transform: "translate(-366.845 -709.691)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3930",
    d: "M609.219 782.734c1.379.411 2.918.938 3.93 1.349l-1.54 1.232a39.018 39.018 0 0 0-4.707-1.7l1.232-.88h-4l1.129.792a19.551 19.551 0 0 1-4.546 1.76 15.307 15.307 0 0 0-1.32-1.246 17.9 17.9 0 0 0 3.784-1.305h-2.3v-6.482h10.72v6.482zm1.862-7.024h-9.546v-3.666h9.546zm-8.476 2.361h7.186v-.63h-7.186zm0 1.731h7.186v-.616h-7.186zm0 1.76h7.186v-.645h-7.186zm6.614-8.153h-5.924v.953h5.924z",
    transform: "translate(-555.701 -715.436)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3931",
    d: "M823.524 796.044v1.76h-13.33v-1.76h5.587v-7.582h-4.8v-1.818H822.7v1.818h-4.927v7.582z",
    transform: "translate(-751.045 -728.965)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3932",
    d: "M194.569 1008.9H188.4v-1.378h2.566a18.5 18.5 0 0 0-.953-1.848l1.364-.631a14.569 14.569 0 0 1 1.071 1.951l-.953.528h3.08zm-5.528.66h4.913v1.32h-4.914zm4.9 3.285h-4.9v-1.32h4.9zm.044 5.147h-3.417v.616H189.1v-5.059h4.883zm-3.417-1.408h1.906v-1.643h-1.906zm11.042-4.9h-2.713v7.113h-1.818v-7.113h-2.569v-1.716h2.566v-4.6h1.818v4.6h2.713z",
    transform: "translate(-174.837 -931.352)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3933",
    d: "M399.547 1008.044h.777v1.056h-.777v1.466h-2.7v.44h2.86v.953h-2.86v.44h3.4v1.115h-8.168v-1.114h3.211v-.44h-2.581v-.953h2.581v-.44h-2.552v-.939h2.552v-.528H392v-1.056h3.3v-.469h-2.508v-.939h2.508v-.792h1.555v.792h2.7zm-7.547 9.81c2.082-.059 5.294-.161 8.3-.293l-.044 1.305c-2.933.132-6.056.264-8.139.337zm7.625-.572h-6.863v-3.358h6.863zm-5.514-2.068h1.349v-.484h-1.349zm0 1.247h1.349v-.469h-1.349zm2.742-8.417h1.232v-.469h-1.232zm1.232 1.056h-1.232v.528h1.232zm.117 5.631h-1.29v.484h1.29zm0 1.261h-1.29v.469h1.29zm4.121-.117h-1.584v-8.256h1.584zm2.83-9.737v11.379c0 .924-.191 1.393-.719 1.657a5.452 5.452 0 0 1-2.478.337 6.754 6.754 0 0 0-.528-1.716c.777.029 1.5.029 1.745.029s.323-.074.323-.308v-11.379z",
    transform: "translate(-363.509 -932.094)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3934",
    d: "M600.028 1016.055a17.849 17.849 0 0 1-.616 3.563 5.682 5.682 0 0 0-1.217-.425 13.542 13.542 0 0 0 .572-3.344zm11.614 2.141c0 .777-.132 1.173-.587 1.422a4.424 4.424 0 0 1-2.038.293 5.334 5.334 0 0 0-.425-1.481c.5.029 1.056.029 1.247.029s.249-.073.249-.264v-9.854h-4.707v11.585h-1.554v-5.177l-1.173.5c-.03-.176-.088-.4-.147-.616a19.163 19.163 0 0 0-3.681.748 11.1 11.1 0 0 0-.469-1.393c.352-.088.66-.44 1.1-1a13.458 13.458 0 0 0 .938-1.305 5.279 5.279 0 0 0-1.657.322 14.585 14.585 0 0 0-.484-1.393c.264-.073.513-.352.792-.792a17.059 17.059 0 0 0 1.672-3.578l1.393.587a22.559 22.559 0 0 1-1.921 3.578l1.041-.073c.352-.66.719-1.364 1.027-2.068l1.261.821a26.806 26.806 0 0 1-2.977 4.56l1.6-.22c-.117-.352-.235-.7-.352-1l1.114-.425c.337.806.719 1.892.924 2.566v-7.743h7.816zm-10.148-2.449c.176.968.337 2.2.4 3.05l-1.217.322a30.238 30.238 0 0 0-.323-3.079zm1.466-.425a21.772 21.772 0 0 1 .836 2.742l-1.129.44a23.385 23.385 0 0 0-.762-2.815zm5.866.718a4.063 4.063 0 0 0 .851-.088c.029.352.059.851.1 1.173a2.817 2.817 0 0 1-.909.088h-1.232c-1.246 0-1.5-.469-1.5-1.642v-.865h-.425v-1.306h1.489a9.193 9.193 0 0 0-.367-.953l.88-.279h-2.068v-1.3h.792a7.664 7.664 0 0 0-.542-1.907l.982-.322a8.024 8.024 0 0 1 .631 1.936l-.851.293h1.291a17.642 17.642 0 0 0 .513-2.2l1.173.308c-.205.631-.411 1.334-.587 1.892h.748v1.3h-1.716a6.231 6.231 0 0 1 .44 1.012l-.587.22h1.8v1.305h-2.214v.88c0 .323.044.455.279.455z",
    transform: "translate(-554.59 -932.463)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3935",
    d: "M819.032 1007.486v1.657h-10.514v2.053c0 2.376-.22 6.042-1.584 8.344a7.765 7.765 0 0 0-1.54-1.012c1.232-2.112 1.334-5.206 1.334-7.347v-3.7h5.485a8.246 8.246 0 0 0-.513-1.276l1.745-.367a7.419 7.419 0 0 1 .733 1.643zm-4.839 3.461h4.487v1.569h-4.487v1.349h3.8v5.5H816.2v-.572h-5.147v.572h-1.716v-5.5h3.05v-4.282h1.8zm2.009 4.517h-5.147v1.789h5.145z",
    transform: "translate(-746.597 -932.094)",
    style: {
      fill: "#333"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4205"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3936",
    d: "M241.68 486.067v-4.56H246v14.947h-3.543v-10.387z",
    transform: "translate(-223.681 -446.201)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3937",
    d: "M362.483 489.352a3.7 3.7 0 1 1 3.7-3.691 3.7 3.7 0 0 1-3.7 3.687m-.017-11.435a7.738 7.738 0 1 0 .012 0h-.012",
    transform: "translate(-328.449 -442.875)",
    style: {
      fillRule: "evenodd",
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3938",
    d: "M732.23 489.352a3.7 3.7 0 1 1 3.7-3.691 3.7 3.7 0 0 1-3.7 3.687m0-11.435a7.736 7.736 0 1 0 7.732 7.74 7.74 7.74 0 0 0-7.732-7.736",
    transform: "translate(-671.089 -442.875)",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3939",
    d: "M611.515 486.067v-4.56h4.319v14.947H612.3v-10.387z",
    transform: "translate(-566.398 -446.201)",
    style: {
      fill: "#333"
    }
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIc1010ShoppingBagZh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-1010ShoppingBag-zh.910c199ba33d77e67b1c0807c2c808db.svg";